import businessClient from 'src/services/clients/business'
import { IMeta, IStaff, IStaffUpsertArgs } from 'src/common/interfaces/index.js'

const IStaffListResponse = { meta: IMeta, data: { list: [IStaff] } }
const IBulkActivateArgs = { ids: [1], is_active: false }
const IBulkActivateResponse = { meta: IMeta, data: { update: [] } }

export const staff = {
  /**
   * @param {{id: number}} filter
   * @return {Promise<IStaffListResponse>}
   */
  list(filter, signal) {
    return businessClient().post('staff/entity/portal/list', { filter }, { signal })
  },

  /**
   * @param {IStaffUpsertArgs} data
   * @return {Promise<{staff: IStaff}>}
   */
  upsert(data, signal) {
    return businessClient().post('staff/entity/upsert', { data }, { signal })
  },

  /**
   * @param {{id: number}} filter
   * @return {IStaff}
   */
  archive(filter, signal) {
    return businessClient().post('staff/entity/archive', { filter }, { signal })
  },

  /**
   * @param {IBulkActivateArgs} data
   * @return {IBulkActivateResponse}
   */
  bulkActivate(data, signal) {
    return businessClient().post('staff/entity/bulk/update', { data }, { signal })
  },
}
